export default {
  suppliers: [],
  supplier: undefined,
};
